import Table from '@ui-library/table';
import Button from '@ui-library/button';
import React from 'react';
import Styled from 'styled-components';
import { FixMe } from '@utils/types';
import classes from './report-errors-view.module.scss';

interface IReportError {
  count: number;
  statusCode: number;
  sampleResponse: string;
  sampleEvent: FixMe;
}
interface ReportErrorsViewProps {
  errors: IReportError[];
  type: string;
  onClickSample?: (data: FixMe, view: string) => void;
}
const Container = Styled.div`
  width:100%;
`;

const ReportErrorsView = ({ errors, type, onClickSample }: ReportErrorsViewProps) => {
  const sampleEventName = type === 'sources' ? 'SAMPLES' : 'SAMPLE EVENT';
  const extraCols =
    type !== 'sources'
      ? [
          {
            title: <div className={classes.header_column}>STATUS CODE</div>,
            dataIndex: 'statusCode',
            key: 'address',
            render: (data: FixMe) => data || '-',
          },
        ]
      : [];
  const columns = [
    {
      title: <div className={classes.header_column}>{sampleEventName}</div>,
      dataIndex: 'sampleEvent',
      key: 'name',
      render: (data: FixMe, rowData: FixMe) =>
        data ? (
          <Button
            type="link"
            style={{ borderRadius: 20 }}
            disabled={!data}
            onClick={onClickSample && (() => onClickSample(rowData!, 'sample'))}
            className={classes.cta_text}
            name={type === 'sources' ? 'Samples' : 'Sample Event'}
          />
        ) : (
          'No sample found'
        ),
    },
    {
      title: <div className={classes.header_column}>ERROR MESSAGE</div>,
      dataIndex: 'sampleResponse',
      key: 'age',
      render: (data: string, rowData: FixMe) =>
        data && data.length > 20 ? (
          <Button
            type="link"
            disabled={!data}
            className={classes.cta_text}
            onClick={onClickSample && (() => onClickSample(rowData!, 'error_view'))}
            name={`${data?.substring(0, 20)}...`}
          />
        ) : (
          data || '-'
        ),
    },
    ...extraCols,

    {
      title: <div className={classes.header_column}>COUNT</div>,
      dataIndex: 'count',
      key: 'count',
      render: (count: FixMe) => count || '-',
    },
  ];
  return (
    <Container>
      <Table dataSource={errors} columns={columns} pagination={false} />
    </Container>
  );
};

export default ReportErrorsView;
